/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProductImageDesign,
    MelcoFusionModelsCustomProductImageDesignFromJSON,
    MelcoFusionModelsCustomProductImageDesignFromJSONTyped,
    MelcoFusionModelsCustomProductImageDesignToJSON,
    MelcoFusionModelsRendererRect,
    MelcoFusionModelsRendererRectFromJSON,
    MelcoFusionModelsRendererRectFromJSONTyped,
    MelcoFusionModelsRendererRectToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsCustomProductImage
 */
export interface MelcoFusionModelsCustomProductImage {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsCustomProductImage
     */
    id?: string | null;
    /**
     * 
     * @type {MelcoFusionModelsRendererRect}
     * @memberof MelcoFusionModelsCustomProductImage
     */
    renderer_rect?: MelcoFusionModelsRendererRect;
    /**
     * 
     * @type {Array<MelcoFusionModelsCustomProductImageDesign>}
     * @memberof MelcoFusionModelsCustomProductImage
     */
    design_list?: Array<MelcoFusionModelsCustomProductImageDesign> | null;
}

export function MelcoFusionModelsCustomProductImageFromJSON(json: any): MelcoFusionModelsCustomProductImage {
    return MelcoFusionModelsCustomProductImageFromJSONTyped(json, false);
}

export function MelcoFusionModelsCustomProductImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsCustomProductImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'renderer_rect': !exists(json, 'renderer_rect') ? undefined : MelcoFusionModelsRendererRectFromJSON(json['renderer_rect']),
        'design_list': !exists(json, 'design_list') ? undefined : (json['design_list'] === null ? null : (json['design_list'] as Array<any>).map(MelcoFusionModelsCustomProductImageDesignFromJSON)),
    };
}

export function MelcoFusionModelsCustomProductImageToJSON(value?: MelcoFusionModelsCustomProductImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'renderer_rect': MelcoFusionModelsRendererRectToJSON(value.renderer_rect),
        'design_list': value.design_list === undefined ? undefined : (value.design_list === null ? null : (value.design_list as Array<any>).map(MelcoFusionModelsCustomProductImageDesignToJSON)),
    };
}


